











































































































import RouteTab from '@/components/RouteTab.vue';
import { Component, Vue, Watch } from 'vue-property-decorator';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import Toast from '@/components/display/toast.vue';
import infoTabs from '@/layouts/parent/BTabsParent.vue';
import { SimCardService } from '@/services/sim-card-service';
import { getApnDisplayName } from '@/common/SimApnUtil';
import { SimCard, SimCardStatus } from '@/api';

@Component({
	components: {
		RouteTab,
		secondaryNav,
		Toast,
		infoTabs,
	},
})
export default class AccessoryView extends Vue {
	public simCard: SimCard | null = null;
	public simCardStatus: SimCardStatus | null = null;
	public simCardStatusLoading: boolean = false;
	public loading = true;
	public failure = false;
	private toast: Toast = new Toast();
	private simCardService: SimCardService = new SimCardService();
	public audits: any[] | null = null;

	public auditFields: any[] | null = [
		{ key: 'created_at', label: 'Date Sent' },
		{ key: 'old_values', label: 'From' },
		{ key: 'new_values', label: 'To' },
		{ key: 'user.name', label: 'By' },
	];

	public get generalFields(): { label: string; value: () => string; isDate: boolean }[] {
		return [
			{ label: 'ICCID', value: () => this.simCard?.iccid ?? '', isDate: false },
			{ label: 'IMSI', value: () => this.simCard?.imsi ?? '', isDate: false },
			{
				label: 'APN',
				value: () => {
					const apn = this.simCard?.apn;
					const apnDisplayName = getApnDisplayName(apn);
					return apn ? `${apn}${apnDisplayName ? ` | ${apnDisplayName}` : ''}` : '';
				},
				isDate: false,
			},
			{ label: 'Created', value: () => this.simCard?.created_at ?? '', isDate: true },
			{ label: 'Updated', value: () => this.simCard?.updated_at ?? '', isDate: true },
			{ label: 'Deleted', value: () => this.simCard?.deleted_at ?? '', isDate: true },
		];
	}

	public get statusFields(): { label: string; value: () => string; isProviderData: boolean }[] {
		return [
			{ label: 'Profile', value: () => this.simCardStatus?.profile ?? '', isProviderData: false },
			{ label: 'State', value: () => this.simCardStatus?.state ?? '', isProviderData: false },
			{
				label: 'Provider Data',
				value: () => JSON.stringify(this.simCardStatus?.providerData, null, 2) ?? '',
				isProviderData: true,
			},
		];
	}

	public async getSimCardStatus() {
		const simId = this.simCard?.id ?? parseInt(this.$route.params.simId, 10);
		this.simCardStatusLoading = true;
		const { simCardStatus, errorMessage } = await this.simCardService.getSimCardStatus(simId, 10);

		if (simId !== parseInt(this.$route.params.simId, 10)) return;

		if (simCardStatus) {
			this.simCardStatus = simCardStatus.data;
		} else if (errorMessage) {
			this.simCardStatus = null;
			this.toast.makeToast(errorMessage, 'SIM Card status error', 'danger');
		}

		this.simCardStatusLoading = false;
	}

	@Watch('$route.params.simId')
	public async load() {
		const { simId } = this.$route.params;
		this.loading = true;
		this.failure = false;
		this.simCard = null;
		this.simCardStatus = null;
		this.simCardStatusLoading = false;
		this.audits = [];

		const { simCard, errorMessage } = await this.simCardService.getSimCardById(
			parseInt(simId, 10),
			{
				params: { include: 'audits, audits.user, transceiver' },
			},
		);

		if (this.$route.params.simId !== simId) return;

		if (simCard) {
			this.simCard = simCard;
			this.audits = this.simCard.audits ?? [];
		} else if (errorMessage) {
			this.failure = true;
			this.simCard = null;
			this.toast.makeToast(errorMessage, 'SIM Card Error', 'danger');
		}

		this.loading = false;
	}

	public created() {
		this.load();
	}
}
